import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Mobile from '../Responsive/Mobile';
import Desktop from '../Responsive/Desktop';
import Stepper from '../Stepper';
import styles from './index.scss';
import { scrolling } from '../../../utils/scrolling';

class HeaderBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reseller: window.tradeUPSUserReseller || false,
            transient: window.tradeUPSUserTransient || false,
            loginUrl: window.tradeLoginUrl || '',
        };
    }
    componentDidMount() {
        document.querySelector('body').addEventListener('click', e => {
            if (e.target.getAttribute('href') === '#trade-it') {
                e.preventDefault();
                const tradeItBlock = document.querySelector('#trade-it').parentElement;
                const header = document.querySelector('.js-header-apc');
                const positionTradeItBlock = tradeItBlock.offsetTop - header.offsetHeight;
                scrolling({ to: positionTradeItBlock, duration: 300 });
            }
        });
    }
    /**
     * Renders component
     * @returns {*}
     */
    render() {
        const { header } = this.props;
        const keyDescription =
            (this.state.reseller && 'tradeUps_tradeIn35') ||
            (!this.state.transient && 'tradeUps_tradeIn25') ||
            'tradeUps_tradeInOrLogin';
        return (
            <div className={styles.HeaderBanner_Wrapper}>
                <Desktop>
                    <div className={styles.HeaderBanner_Background} />
                    <div className={`tradeUpsContainer ${styles.HeaderBanner_Container}`}>
                        <div className={styles.HeaderBanner}>
                            <div className={styles.HeaderBanner_Content}>
                                <div className={styles.row}>
                                    <div className={styles.col}>
                                        {!this.state.reseller ? (
                                            <FormattedMessage id={header}>
                                                {txt => <h1 className={styles.HeaderBanner_Content_Heading}>{txt}</h1>}
                                            </FormattedMessage>
                                        ) : (
                                            <FormattedMessage id="tradeUps_forResellers">
                                                {txt => <h1 className={styles.HeaderBanner_Content_Heading}>{txt}</h1>}
                                            </FormattedMessage>
                                        )}
                                    </div>
                                </div>

                                <p className={styles.HeaderBanner_Content_subheading}>
                                    <FormattedHTMLMessage id={keyDescription} />
                                </p>
                            </div>
                        </div>
                        <Stepper
                            activeStep={1}
                            steps={[
                                { title: <FormattedMessage id={'tradeUps_tradeIn'} /> },
                                { title: <FormattedMessage id={'L_MSG_CHOOSE_PRODUCTS_Txt'} /> },
                                { title: <FormattedMessage id={'tradeUps_chooseAccessories'} /> },
                            ]}
                        />
                    </div>
                </Desktop>
                <Mobile>
                    <div className={styles.HeaderBanner_Background} />
                    <div className={`tradeUpsContainer ${styles.HeaderBanner_Container}`}>
                        <div className={`${styles.HeaderBanner} mobileContainerPadding`}>
                            <div className={styles.HeaderBanner_Content}>
                                <div className={styles.HeaderBanner_Content_Header}>
                                    <div className={styles.row}>
                                        <div className={styles.col}>
                                            {!this.state.reseller ? (
                                                <FormattedMessage id={header}>
                                                    {txt => (
                                                        <h1 className={styles.HeaderBanner_Content_Heading}>{txt}</h1>
                                                    )}
                                                </FormattedMessage>
                                            ) : (
                                                <FormattedMessage id="tradeUps_forResellers">
                                                    {txt => (
                                                        <h1 className={styles.HeaderBanner_Content_Heading}>{txt}</h1>
                                                    )}
                                                </FormattedMessage>
                                            )}
                                        </div>
                                    </div>

                                    <p className={styles.HeaderBanner_Content_subheading}>
                                        <FormattedHTMLMessage id={keyDescription} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.StepperWrapper}>
                        <div className="tradeUpsContainer">
                            <Stepper
                                activeStep={1}
                                steps={[
                                    { title: <FormattedMessage id={'tradeUps_tradeIn'} /> },
                                    { title: <FormattedMessage id={'L_MSG_CHOOSE_PRODUCTS_Txt'} /> },
                                    { title: <FormattedMessage id={'tradeUps_chooseAccessories'} /> },
                                ]}
                            />
                        </div>
                    </div>
                </Mobile>
            </div>
        );
    }
}

HeaderBanner.propTypes = {
    header: PropTypes.string.isRequired,
};

HeaderBanner.defaultProps = {
    header: '',
};

export default HeaderBanner;
